export default {
    userBreif: state => {
        return state.userInfo;
    },
    realUserInfo: state => {
        return state.realUserInfo;
    },
    activity: state => {
        return state.activity;
    },
    status: state => {
        return state.status;
    },
    mediaAccounts: state => {
        return state.mediaAccounts;
    },
    mediaDistributeCovers: state =>{
        return state.mediaDistributeCovers;
    },
    mediaDistributeData: state =>{
        return state.mediaDistributeData;
    },
    accountRejectReason: state =>{
        return state.accountRejectReason;
    },
    reportNum: state =>{
        return state.reportNum;
    },
    noticeList: state =>{
        return state.noticeList;
    },
    banInfo: state =>{
        return state.banInfo;
    },
    hasAuth: state =>{
        return state.hasAuth;
    }
}
